import { createQueryKeys } from "@lukemorales/query-key-factory"

export const tenantQueries = createQueryKeys("tenant", {
  info: null
})
